import { BaseMapper } from '@ps/utils';
import { SurveyLocationUploadResult } from '@ps/survey-utils';

import {
  FsaUploadResponseDto,
  LocationUploadResponseDto,
  ZipcodeUploadResponseDto,
} from '../dtos/location-upload.dto';

const _isFsaUpload = (
  dto: LocationUploadResponseDto,
): dto is FsaUploadResponseDto => 'fsaFilePath' in dto;

export class LocationUploadMapper extends BaseMapper<
  LocationUploadResponseDto,
  SurveyLocationUploadResult
> {
  public fromDto(dto: LocationUploadResponseDto): SurveyLocationUploadResult {
    return _isFsaUpload(dto)
      ? this._fromFsaUpload(dto)
      : this._fromZipcodeUpload(dto);
  }

  private _fromFsaUpload(
    dto: FsaUploadResponseDto,
  ): SurveyLocationUploadResult {
    const summary = dto.zipcodes;

    return {
      validCodes: summary.fsaList.map((code) => code.name || code.id),
      totalCodeCount: summary.total,
      correctCodeCount: summary.correct,
      duplicateCodeCount: summary.duplicate,
      incorrectCodeCount: summary.incorrect,
      incorrectCodes: [],
      modifiedCodeCount: 0,
      filePath: dto.fsaFilePath,
      groupedCodes: summary.grouped,
    };
  }

  private _fromZipcodeUpload(
    dto: ZipcodeUploadResponseDto,
  ): SurveyLocationUploadResult {
    const summary = dto.zipcodes;

    return {
      validCodes: summary.validZipcodes,
      totalCodeCount: summary.totalZipcodes,
      correctCodeCount: summary.correctZipcodes,
      duplicateCodeCount: summary.duplicateZipcodes,
      incorrectCodeCount: summary.incorrectZipcodes,
      incorrectCodes: summary.incorrectZipCodesList ?? [],
      modifiedCodeCount: summary.modifiedZipcodes,
      filePath: dto.zipcodeFilePath,
      groupedCodes: summary.groupedZipCodes,
    };
  }
}
